import { render } from "./RIcon.vue?vue&type=template&id=71a8eadc"
import script from "./RIcon.vue?vue&type=script&lang=js"
export * from "./RIcon.vue?vue&type=script&lang=js"

import "./RIcon.vue?vue&type=style&index=0&id=71a8eadc&lang=css"
script.render = render

export default script